module.exports = "/_next/static/resources/circle-of-care-2b5e075667e2a114e1488a2bb0ec9b3b.mp4";